import useAppContext from "@casino/legacy/shared/context/AppContext/useAppContext";
import { cn } from "@workspace/frontend-ui";

type Props = {
  short?: boolean;
  className?: string;
};

const Logo: FC<Props> = ({ short, className }) => {
  const { brandLogos } = useAppContext();
  const src = short ? brandLogos.icon : brandLogos.full;

  if (!src) {
    return null;
  }

  return (
    <img
      src={src}
      alt={brandLogos.name}
      className={cn(short ? "mx-2 w-[30px]" : "w-[150px]", className)}
    />
  );
};

export default Logo;
